enum GooglePayCustomerMethodType {
    GOOGLEPAY_ADYENV2 = 'googlepayadyenv2',
    GOOGLEPAY_ADYENV3 = 'googlepayadyenv3',
    GOOGLEPAY_AUTHORIZENET = 'googlepayauthorizenet',
    GOOGLEPAY_BNZ = 'googlepaybnz',
    GOOGLEPAY_BRAINTREE = 'googlepaybraintree',
    GOOGLEPAY_CHECKOUTCOM = 'googlepaycheckoutcom',
    GOOGLEPAY_CYBERSOURCEV2 = 'googlepaycybersourcev2',
    GOOGLEPAY_ORBITAL = 'googlepayorbital',
    GOOGLEPAY_STRIPE = 'googlepaystripe',
    GOOGLEPAY_STRIPEUPE = 'googlepaystripeupe',
    GOOGLEPAY_WORLDPAYACCESS = 'googlepayworldpayaccess',
}

export default GooglePayCustomerMethodType;
